/* eslint-disable camelcase */
import {ConfigProvider, App as AntdApp} from 'antd';
import {createCache, extractStyle, StyleProvider} from '@ant-design/cssinjs';
import en_US from 'antd/locale/en_US';
import zh_TW from 'antd/locale/zh_TW';
import useCommon from '@utils/hooks/common';

// eslint-disable-next-line react/prop-types
const AntConfigProvider = ({children}) => {
  const {currentLanguage, theme} = useCommon({
    observers: [
      ({language}) =>
        () => ({
          currentLanguage: language.currentLanguage,
        }),
    ],
  });

  // console.log('currentLanguage',currentLanguage)
  const getLocale = () => {
    switch (currentLanguage) {
      case 'zh-HK':
        return zh_TW;
      case 'zh-TW':
        return zh_TW;
      // case 'zh-CN':
      //   return zh_CN;
      // case 'ja-JP':
      //   return ja_JP;
      // case 'ko-KR':
      //   return ko_KR;
      default:
        return en_US;
    }
  };
  return (
    <StyleProvider layer>
      <ConfigProvider
        theme={{
          token: {
            colorText: 'white',
            colorTextPlaceholder: 'rgba(255, 255, 255, 0.5)',
            fontFamily:
              "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'",
          },
          components: {
            Radio: {
              dotSize: 12,
              radioSize: 20,
            },
            Slider: {
              handleSize: 0,
              handleSizeHover: 0,
              handleColor: 'transparent',
              handleActiveColor: 'transparent',
              handleActiveOutlineColor: 'transparent',
              handleLineWidth: 0,
              handleLineWidthHover: 0,
            },
            Tabs: {
              inkBarColor: 'white',
              itemSelectedColor: 'white',
              itemHoverColor: 'white',
              itemColor: 'rgba(255, 255, 255, 0.5)',
            },
          },
        }}
        locale={getLocale()}
        button={{
          autoInsertSpace: true,
        }}
      >
        {children}
      </ConfigProvider>
    </StyleProvider>
  );
};

export default AntConfigProvider;
